
import { TextSectionMetadataBase } from './text-section.metadata.base';


export class TextSectionMetadata extends TextSectionMetadataBase {
  constructor() {
    super();
  }
}

export const TEXT_SECTION_METADATA: TextSectionMetadata = new TextSectionMetadata();


